import { useQuickPicksFilters } from './useQuickPicksFilters';

export function useLeagueIconUrl(leagueId: string): string | undefined {
  const { data } = useQuickPicksFilters();
  return data?.filters?.leagues?.find((l) => l.id === leagueId)?.icon_url;
}
